import Collapse from "../../components/layout/PPCollapse"
import countries from "i18n-iso-countries"
import i18n_iso_countrie_de from "i18n-iso-countries/langs/de.json"
import { useTranslation } from "react-i18next"

countries.registerLocale(i18n_iso_countrie_de)

function PPStatsBox(props) {
    const [t] = useTranslation()

    const icon = props.icon ? <i className={"fas " + props.icon + " dashboard-icon"} /> : ""

    function showMoreClick() {
        props.onChildClick(props.className)
    }

    return (
        <div className={"small-box shadow " + props.cssClass}>
            <div className="inner min-height">
                <h3>{props.value}</h3>
                <div
                    className={"text-and-icon"}
                    style={{
                        display: "flex",
                        gridTemplateColumns: "auto 1fr",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                    <p>{props.text}</p>
                    <p>{icon}</p>
                </div>
            </div>
            {props.hasNoShowMore ? (
                <div
                    style={{
                        cursor: "auto",
                        borderRadius: "0px 0px 3px 3px",
                        color: "grey"
                    }}
                    className={"small-box-footer "}>
                    &nbsp;
                </div>
            ) : (
                <button
                    type="button"
                    style={{
                        cursor: "pointer",
                        borderRadius: "0px 0px 3px 3px",
                        color: "grey"
                    }}
                    onClick={() => showMoreClick()}
                    className={"small-box-footer "}
                    aria-expanded="false"
                    aria-controls={"collapse" + props.collapseBoxId}>
                    {props.showMore ? t("single.more") : t("single.less")}{" "}
                    <i className={props.showMore ? "fas fa-arrow-circle-right" : "fas fa-arrow-circle-up"} />
                </button>
            )}
        </div>
    )
}

function DetailStatsPricesRow(props) {
    let linkId = props.searchName === "Shop" ? props.obj.id : props.categoryName

    return (
        <tr>
            <td>{props.rowNumber}.</td>
            <td>
                <a href={`/pricetable/${linkId}/${props.searchName}/${props.sortProperty}`}>{props.categoryName}</a>
            </td>
            {props.searchName === "Shop" && (
                <td>
                    <span
                        title={countries.getName(props.lang, props.i18n.language)}
                        className={"fi fi-" + props.lang}
                    />
                </td>
            )}
            <td>{props.totalCount}</td>
            <td>{props.count}</td>
            <td>
                <div className="progress progress-xs">
                    <div
                        className="progress-bar progress-bar-danger"
                        style={{ width: Number(props.percent.toFixed(2)) + "%" }}
                    />
                </div>
            </td>
            <td>{Number(props.percent.toFixed(2))}%</td>
        </tr>
    )
}

function DetailStatsPrices(props) {
    const [t, i18n] = useTranslation()

    if (props.items === null) {
        return t("errors.no_correct_server_data")
    }

    let rows = Array.from(props.items).map((obj, index) => (
        <DetailStatsPricesRow
            key={index + "_" + JSON.stringify(obj)}
            rowNumber={index + 1}
            categoryName={obj.name}
            totalCount={obj.totalCount}
            count={obj.count}
            percent={obj.percentage}
            lang={obj.lang}
            tabName={props.tabName}
            searchName={props.searchName}
            sortProperty={props.sortProperty}
            obj={obj}
            i18n={i18n}
        />
    ))

    return (
        <Collapse in={props.open}>
            <div className="card">
                <div className="card-body p-0">
                    <div className="table-responsive" overflow="auto">
                        <table className="table table-striped dt-responsive">
                            <thead>
                                <tr>
                                    <th className={"width-10"}>#</th>
                                    <th>{props.tabName}</th>
                                    {props.tabName === "Shop" && <th>{t("single.language")}</th>}
                                    <th>{t("single.total_count")}</th>
                                    <th>{t("single.count")}</th>
                                    <th>{t("single.proportion")}</th>
                                    <th style={{ width: "40px" }}></th>
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Collapse>
    )
}

function DetailStatsShops(props) {
    const [t, i18n] = useTranslation()

    if (props.items === null) {
        return t("errors.no_correct_server_data")
    }

    let rows = Array.from(props.items).map((obj) => (
        <DetailStatsShopsRow key={obj.id} id={obj.id} name={obj.name} lang={obj.lang} domain={obj.domain} i18n={i18n} />
    ))

    return (
        <Collapse in={props.open}>
            <div className="card shadow">
                <div className="card-body p-0">
                    <div className="col" style={{ marginTop: 0.5 + "rem" }}>
                        <a href="./settings" className="btn btn-outline-primary nav-link">
                            {t("dashboard.show_all_shops")}
                        </a>
                    </div>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className={"width-10"}>#</th>
                                    <th>{t("single.name")}</th>
                                    <th>{t("single.language")}</th>
                                    <th>Domain</th>
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Collapse>
    )
}

function DetailStatsCompetitorMostPriceChanges(props) {
    const [t, i18n] = useTranslation()

    if (props.items === null) {
        return t("errors.no_correct_server_data")
    }

    let rows = Array.from(props.items)
        .sort((a, b) => a.countPriceChangesLastTwoWeeks - b.countPriceChangesLastTwoWeeks)
        .reverse()
        .map((obj, index) => (
            <DetailStatsCompetitorMostPriceChangesRow
                key={obj.name + obj.lang}
                rowNumber={index + 1}
                competitor={obj.name}
                priceChanges={obj.countPriceChangesLastTwoWeeks}
                lang={obj.lang}
                i18n={i18n}
            />
        ))

    return (
        <Collapse in={props.open}>
            <div className="card">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className={"width-10"}>#</th>
                                    <th>{t("single.name")}</th>
                                    <th>{t("single.language")}</th>
                                    <th>{t("dashboard.price_changes")}</th>
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Collapse>
    )
}

function DetailStatsCompetitorMostPriceChangesRow(props) {
    return (
        <tr>
            <td>{props.rowNumber}.</td>
            <td>{props.competitor}</td>
            <td>
                <span title={countries.getName(props.lang, props.i18n.language)} className={"fi fi-" + props.lang} />
            </td>
            <td>{props.priceChanges}</td>
        </tr>
    )
}

function DetailStatsCompetitorLowestPrice(props) {
    const [t, i18n] = useTranslation()

    if (props.items === null) {
        return t("errors.no_correct_server_data")
    }

    let rows = Array.from(props.items)
        .sort((a, b) => a.count - b.count)
        .reverse()
        .map((obj, index) => (
            <DetailStatsCompetitorLowestPriceRow
                key={obj.name + obj.lang}
                rowNumber={index + 1}
                competitor={obj.name}
                lowestPriceCount={obj.count}
                lang={obj.lang}
                i18n={i18n}
            />
        ))

    return (
        <Collapse in={props.open}>
            <div className="card">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className={"width-10"}>#</th>
                                    <th>{t("single.name")}</th>
                                    <th>{t("single.language")}</th>
                                    <th>{t("dashboard.lowest_price")}</th>
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Collapse>
    )
}

function DetailStatsCompetitorLowestPriceRow(props) {
    return (
        <tr>
            <td>{props.rowNumber}.</td>
            <td>{props.competitor}</td>
            <td>
                <span title={countries.getName(props.lang, props.i18n.language)} className={"fi fi-" + props.lang} />
            </td>
            <td>{props.lowestPriceCount}</td>
        </tr>
    )
}

function DetailStatsShopsRow(props) {
    return (
        <tr>
            <td>{props.id}.</td>
            <td>{props.name}</td>
            <td>
                <span title={countries.getName(props.lang, props.i18n.language)} className={"fi fi-" + props.lang} />
            </td>
            <td>{props.domain}</td>
        </tr>
    )
}


export { PPStatsBox, DetailStatsPrices, DetailStatsShops, DetailStatsCompetitorMostPriceChanges, DetailStatsCompetitorLowestPrice }
